module.exports = __webpack_public_path__ + "static/img/logInfo.5b957e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logInfo.png
// module id = LQrv
// module chunks = 1